"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalExperimentToJSON = exports.InternalExperimentFromJSONTyped = exports.InternalExperimentFromJSON = exports.instanceOfInternalExperiment = void 0;
var runtime_1 = require("../runtime");
var ExperimentType_1 = require("./ExperimentType");
var HoldoutLevel_1 = require("./HoldoutLevel");
/**
 * Check if a given object implements the InternalExperiment interface.
 */
function instanceOfInternalExperiment(value) {
    var isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
exports.instanceOfInternalExperiment = instanceOfInternalExperiment;
function InternalExperimentFromJSON(json) {
    return InternalExperimentFromJSONTyped(json, false);
}
exports.InternalExperimentFromJSON = InternalExperimentFromJSON;
function InternalExperimentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'type': (0, ExperimentType_1.ExperimentTypeFromJSON)(json['type']),
        'name': json['name'],
        'startDate': !(0, runtime_1.exists)(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'eligibilityCampaignIds': !(0, runtime_1.exists)(json, 'eligibility_campaign_ids') ? undefined : json['eligibility_campaign_ids'],
        'isTest': !(0, runtime_1.exists)(json, 'is_test') ? undefined : json['is_test'],
        'market': !(0, runtime_1.exists)(json, 'market') ? undefined : json['market'],
        'holdoutLevel': !(0, runtime_1.exists)(json, 'holdout_level') ? undefined : (0, HoldoutLevel_1.HoldoutLevelFromJSON)(json['holdout_level']),
        'holdoutPercent': !(0, runtime_1.exists)(json, 'holdout_percent') ? undefined : json['holdout_percent'],
        'markets': !(0, runtime_1.exists)(json, 'markets') ? undefined : json['markets'],
        'languages': !(0, runtime_1.exists)(json, 'languages') ? undefined : json['languages'],
        'id': json['id'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'underivedStatus': !(0, runtime_1.exists)(json, 'underivedStatus') ? undefined : json['underivedStatus'],
        'isExposedAudienceCreated': !(0, runtime_1.exists)(json, 'is_exposed_audience_created') ? undefined : json['is_exposed_audience_created'],
        'isControlAudienceCreated': !(0, runtime_1.exists)(json, 'is_control_audience_created') ? undefined : json['is_control_audience_created'],
        'isExposedAudienceMapped': !(0, runtime_1.exists)(json, 'is_exposed_audience_mapped') ? undefined : json['is_exposed_audience_mapped'],
        'isControlAudienceMapped': !(0, runtime_1.exists)(json, 'is_control_audience_mapped') ? undefined : json['is_control_audience_mapped'],
        'isExposedAudienceActivated': !(0, runtime_1.exists)(json, 'is_exposed_audience_activated') ? undefined : json['is_exposed_audience_activated'],
        'isControlAudienceActivated': !(0, runtime_1.exists)(json, 'is_control_audience_activated') ? undefined : json['is_control_audience_activated'],
        'isCampaignCreated': !(0, runtime_1.exists)(json, 'is_campaign_created') ? undefined : json['is_campaign_created'],
        'totalAdSetsCreated': !(0, runtime_1.exists)(json, 'total_ad_sets_created') ? undefined : json['total_ad_sets_created'],
        'totalAssetsCreated': !(0, runtime_1.exists)(json, 'total_assets_created') ? undefined : json['total_assets_created'],
        'totalCreativesCreated': !(0, runtime_1.exists)(json, 'total_creatives_created') ? undefined : json['total_creatives_created'],
        'errorStep': !(0, runtime_1.exists)(json, 'error_step') ? undefined : json['error_step'],
    };
}
exports.InternalExperimentFromJSONTyped = InternalExperimentFromJSONTyped;
function InternalExperimentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_account_id': value.adAccountId,
        'type': (0, ExperimentType_1.ExperimentTypeToJSON)(value.type),
        'name': value.name,
        'start_date': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'eligibility_campaign_ids': value.eligibilityCampaignIds,
        'is_test': value.isTest,
        'market': value.market,
        'holdout_level': (0, HoldoutLevel_1.HoldoutLevelToJSON)(value.holdoutLevel),
        'holdout_percent': value.holdoutPercent,
        'markets': value.markets,
        'languages': value.languages,
        'id': value.id,
        'status': value.status,
        'underivedStatus': value.underivedStatus,
        'is_exposed_audience_created': value.isExposedAudienceCreated,
        'is_control_audience_created': value.isControlAudienceCreated,
        'is_exposed_audience_mapped': value.isExposedAudienceMapped,
        'is_control_audience_mapped': value.isControlAudienceMapped,
        'is_exposed_audience_activated': value.isExposedAudienceActivated,
        'is_control_audience_activated': value.isControlAudienceActivated,
        'is_campaign_created': value.isCampaignCreated,
        'total_ad_sets_created': value.totalAdSetsCreated,
        'total_assets_created': value.totalAssetsCreated,
        'total_creatives_created': value.totalCreativesCreated,
        'error_step': value.errorStep,
    };
}
exports.InternalExperimentToJSON = InternalExperimentToJSON;
